site.searchBox = {
	init: function () {
		$('#searchToggle').on('click', function (e) {
			e.preventDefault();
			var $body = $('body');
			$body.toggleClass('search-open');

			$('body.search-open').on('click', function (e) {
				if (!$(e.target).parents('#header').length) {
					$('body').removeClass('search-open');
				}
			});

			if ($body.is('.search-open') && !$body.is('.tabbing')) {
				$('#q').focus();
			}

			if ($body.hasClass('contact-open')) {
				$body.removeClass('contact-open');
			}
		});
	}
};

site.inits.push('site.searchBox.init()');
